import { render, staticRenderFns } from "./gInput.vue?vue&type=template&id=aa2514e4&"
import script from "./gInput.vue?vue&type=script&lang=js&"
export * from "./gInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "gInput.vue"
export default component.exports